import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  container: FelaCSS;
  originalText: (lineClamp: number) => FelaCSS;
  measurementSpan: (lineClamp: number) => FelaCSS;
}

export const styles: IStyles = {
  container: {
    overflow: 'hidden',
    display: 'block',
    width: '100%',
    whiteSpace: 'initial',
    lineHeight: 'inherit',
  },
  originalText: (lineClamp) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    lineClamp,
    WebkitLineClamp: lineClamp,
    overflow: 'hidden',
    lineHeight: 'inherit',
    // For one-line truncation we want to show ellipsis at the end of the available space
    ...(lineClamp === 1 && { wordBreak: 'break-all' }),
  }),
  // Use a hidden span to measure the actual text without layout constraints
  measurementSpan: (lineClamp) => ({
    position: 'absolute',
    visibility: 'hidden',
    height: 'auto',
    width: 'auto',
    lineHeight: 'inherit',
    ...(lineClamp === 1 && { wordBreak: 'break-all' }),
  }),
};
